import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AccountInfoData {
    full_name: string,
    email: string,
}

export interface CredentialInfoData {
    username: string,
    password: string,
    confirmPassword: string
}

export interface TokenInfoData {
    access_token: string,
    refresh_token: string
}



export interface UserState {
    Account: AccountInfoData;
    Credential: CredentialInfoData;
    token: TokenInfoData
    role: string
}

const initialState: UserState = {
    Account: {
        full_name: "",
        email: "",
    },
    Credential: {
        username: "",
        password: "",
        confirmPassword: ""
    },
    token: {
        access_token: "",
        refresh_token: "",
    },
    role: ""
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        resetUser: (state) => {
            state = initialState;

        },
        setRole: (state, action: PayloadAction<string>) => {
            state.role = action.payload;
        },
        setAccountInfo: (state, action: PayloadAction<{ key: string; value: string }>) => {
            if (!action.payload.value) action.payload.value = "";
            switch (action.payload.key) {
                case "fullname":
                    state.Account.full_name = action.payload.value;
                    break;
                case "email":
                    state.Account.email = action.payload.value
                    break;
            }
        },
        removePassword: (state) => {
            state.Credential.confirmPassword = initialState.Credential.confirmPassword;
            state.Credential.password = initialState.Credential.password
        },
        resetAccountInfo: (state) => {
            state.Account = initialState.Account;
        },
        setToken: (state, action: PayloadAction<TokenInfoData>) => {
            state.token = action.payload;
        },
        setCredentialInfo: (state, action: PayloadAction<{ key: string; value: string }>) => {
            if (!action.payload.value) action.payload.value = "";
            switch (action.payload.key) {
                case "username":
                    state.Credential.username = action.payload.value;
                    break;
                case "password":
                    state.Credential.password = action.payload.value
                    break;
                case "confirmPassword":
                    state.Credential.confirmPassword = action.payload.value
                    break;
            }
        },
        resetCredentialsInfo: (state) => {
            state.Credential = initialState.Credential;
        }
    },
});

export const {
    resetUser,
    setRole,
    setToken,
    removePassword,
    setAccountInfo,
    resetAccountInfo,
    setCredentialInfo,
    resetCredentialsInfo
} = userSlice.actions;
export default userSlice.reducer;
